// extracted by mini-css-extract-plugin
export default {"EdgeUpgradeNotice":"EdgeUpgradeNotice-module-c7d522e5960aa3752ea4","label":"EdgeUpgradeNotice-module-f8a83ee307e1e6a8b23a","dismiss":"EdgeUpgradeNotice-module-c3c16b1a4419d85492aa"};